import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/config";
import { SectionHeading } from "@/components/Section";
import EditorialMarquee from "@/components/EditorialMarquee";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);

  return (
    <section data-testid="testimonials" className="bg-butter">
      <div className="py-24 md:py-32 max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeading
          chapter="11 / Testimonials"
          overline="From the Kitchens We Supply"
          title={<>What food businesses say</>}
          className="mb-12"
        />

        <div className="relative rounded-3xl bg-forest text-cream p-8 md:p-14 border border-forest shadow-hard-lg overflow-hidden">
          <Quote className="h-14 w-14 text-butter-deep/40 mb-6" />
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="font-display text-2xl md:text-4xl leading-[1.2] tracking-tight max-w-4xl"
            >
              “{t.quote}”
            </motion.blockquote>
          </AnimatePresence>
          <div className="flex items-center justify-between mt-8">
            <p className="overline text-butter-deep">{t.who}</p>
            <div className="flex gap-2">
              <button onClick={prev} data-testid="testimonial-prev" aria-label="Previous" className="grid place-items-center h-10 w-10 rounded-full border border-white/25 hover:bg-white hover:text-forest transition-colors"><ChevronLeft className="h-4 w-4" /></button>
              <button onClick={next} data-testid="testimonial-next" aria-label="Next" className="grid place-items-center h-10 w-10 rounded-full border border-white/25 hover:bg-white hover:text-forest transition-colors"><ChevronRight className="h-4 w-4" /></button>
            </div>
          </div>
          <div className="flex gap-1.5 mt-6">
            {TESTIMONIALS.map((_, idx) => (
              <span key={idx} className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-butter-deep" : "w-1.5 bg-white/30"}`} />
            ))}
          </div>
        </div>
      </div>
      <EditorialMarquee tone="forest" />
    </section>
  );
}
